import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  // userInfo,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      // console.log(userInfo, "userInfo");
      if (isAuthProtected && localStorage.getItem("secretkey")) {
        return (
          <Redirect
            to={{ pathname: "/", state: { from: props.location } }}
          />
        );
      }

      // console.log(props, "props")

      return (
        <Layout>
          <Component {...props} {...rest} />
        </Layout>
      );
    }}
  />
);

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  userInfo: PropTypes.any,
};

export default AppRoute;
